import { Card, ConfigProvider, Flex, Progress, Spin } from "antd";
import R from './img/3409297.jpg'
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";


export function Registered(){
    const [loading,setloading]=useState(true);
    const [failed,setFailed] = useState(false);
    const [success,setsuccess] = useState(false)
    const { id } = useParams();

    useEffect(()=>{
        const setFavicon = (iconUrl: string) => {
            const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
            if (link) {
              link.href = iconUrl;
            } else {
              const newLink = document.createElement("link");
              newLink.rel = "icon";
              newLink.href = iconUrl;
              document.head.appendChild(newLink);
            }
          };
      
          // Set external image URL as favicon
          setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
          document.title = "VU_HREC"; 
    })
    useEffect(() => {
        const confirmRegistration = async () => {
          try {
            const response = await axios.post(`${process.env.REACT_APP_BASE}/RegisterConfirmation/${id}`);
            if (response.status === 200) {
                setloading(false);
                setsuccess(true);
            }
          } catch (error) {
            setloading(false);
            setFailed(true);
          }
        };
    
        confirmRegistration();
      }, [id]); // ✅ dependency array with 'id' only — run once on mount

    return(
    <>
        <ConfigProvider
        theme={{
            components: {
                Form: { labelColor: 'black' },
                Segmented: {
                    itemActiveBg: '#D4BDAC',
                    itemSelectedBg: '#FFF1DB',
                    trackBg: 'gray',
                    // itemColor: 'white',
                },
            },
            token: { fontFamily: 'Kanit' },
        }}
    >
        <title>VU HREC</title>
        <div
            style={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundImage: `url(${R})`,
                backgroundSize: '100% 100%',  
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
           <Card
                style={{
                    width: '30vw',
                    height: '55vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0, // remove internal spacing
                }}
                bodyStyle={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                >
                <h1 style={{ marginBottom: 20 }}>ยืนยันการสมัคร</h1>
                {loading&&<>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: '20vh' }} spin />} />
                    <p style={{ marginTop: 10 }}>ระบบกำลังตรวจสอบข้อมูลของท่าน</p>
                    </>||
                 success&&<>
                 <br/>
                 <Progress type="circle" percent={100} width={160} />
                 <br/>
                 <p style={{ fontSize: '2vh', marginTop: 10 }}>ยืนยันข้อมูลเสร็จสิ้น คุณสามารถกดปิดแท็ปนี้ได้</p>
                 </> ||
                 failed&&<>
                 <br/>
                 <Progress type="circle" percent={100} width={160} status="exception" />
                 <br/>
                 <p style={{ fontSize: '2vh', marginTop: 10 }}>การดำเนินงานนี้ไม่สำเร็จเนื่องจากคุณอาจยืนยันการสมัครไปแล้วหรืออาจเลยเวลาการยืนยันตัวตนไปแล้ว</p>
                 <p style={{ fontSize: '2vh', marginTop: 10 }}>กรุณาสมัครสมาชิกใหม่อีกครั้ง</p>
                 </>
                }
            </Card>


        </div>
        
    </ConfigProvider>
    </>)
}